let closeNews = document.querySelector('.close-newsletter-btn');
let newsWrap = document.querySelector('.newsletter-klaviyo');

// setTimeout(function() {
  //newsWrap.classList.add('active');
// }, 5000);

window.addEventListener("load", function () {
  let newsletterStatus = Cookies.get('newsCookie');
  if(newsletterStatus == 'killNewsPop'){
  } else {
    setTimeout(function() {
      document.querySelector('.newsletter-klaviyo').classList.add('active');
    }, 30000);
  }
});
//10000 was the old delay

closeNews.addEventListener('click', function(event){
  event.preventDefault();
  newsWrap.classList.remove('active');
  let newsletterStatus = Cookies.get('newsCookie');
  if(newsletterStatus == 'killNewsPop'){

  } else {
    Cookies.set('newsCookie', 'killNewsPop', { expires: 7 });
  }
  
});

let summonNews = document.querySelector('#summon-newsletter');

summonNews.addEventListener('click', function(event){
  event.preventDefault();
  newsWrap.classList.add('active');
});

// $(document).ready(function () {

//   var utils = utils || {};
//   /*
//    * utils
//    */
//   utils.formValidEmail = function ($form) {
//     var email = $form.find("input[type='email']").val();

//     if (!email || !email.length) {
//       return false;
//     } else if (email.indexOf("@") == -1) {
//       return false;
//     }

//     return true;
//   };

//   // subscribe form
//   $(".subscribe-form").on("submit", function (event) {
//     event.preventDefault();
//     // console.log("Sub form");
//     var _parent = $(this).parent().parent();

//     if (!utils.formValidEmail($(this))) {
//       var error = "A valid email address must be provided.";
//       _parent.find(".subscribe-feedback span").html(error);

//       _parent.find(".subscribe-add").stop(true, false).hide(0).delay(1500).fadeIn(2000);

//       _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500).hide(0);
//     } else {
//       //Moved this to top
//       _parent.find(".subscribe-form").addClass("hide");

//       _parent.find(".subscribe-feedback span").html("Subscribing...");

//       _parent.find(".subscribe-feedback").stop(true, false).show(0);

//       //_parent.find(".subscribe-add").hide();

//       $.ajax({
//         type: "GET",
//         url: $(this).attr("action"),
//         data: $(this).serialize(),
//         cache: false,
//         dataType: "jsonp",
//         jsonp: "c", // trigger MailChimp to return a JSONP response
//         contentType: "application/json; charset=utf-8",
//         error: function (error) {},
//         success: function (data) {
//           if (data.result != "success") {
//             var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";

//             if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
//               message = "You're already subscribed. Thank you.";
//             }

//             _parent.find(".subscribe-feedback span").html(message);
//           } else {
//             _parent.find(".subscribe-feedback span").html("Thank you. Please check your email.");
//           }

//           //_parent.find(".subscribe-add").stop(true, false).hide(0).delay(1500).fadeIn(2000);

//           _parent.find(".subscribe-form").addClass("hide");

//           _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500).hide(0);

//           _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500);

//           //_parent.find(".subscribe-add input").val("").hide(0);
//         },
//       });
//     }
//   });
// });


// document.getElementById('subscribe-form').addEventListener('submit', async function (event) {
//   event.preventDefault(); // Prevent the default form submission

//   const form = event.target;
//   const formData = new FormData(form);
//   const messageDiv = document.getElementById('form-message');

//   try {
//     const response = await fetch('https://sophiebuhai.us10.list-manage.com/subscribe/post', {
//       method: 'POST',
//       body: formData,
//       mode: 'no-cors' // Use no-cors mode to bypass CORS restrictions
//     });

//     // Assuming success, display a thank-you message
//     form.classList.add('hide');
//     messageDiv.style.display = 'block';
//   } catch (error) {
//     console.error('Error:', error);
//     //alert('There was an error subscribing. Please try again later.');
//   }
// });